var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAnalytics(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M13.531,14.266 L14.054,14.266 L14.054,3.2 L13.531,3.2 L13.531,14.266 Z M9.67,14.266 L10.193,14.266 L10.193,8.524 L9.67,8.524 L9.67,14.266 Z M5.81,14.266 L6.333,14.266 L6.333,6.289 L5.81,6.289 L5.81,14.266 Z M1.946,14.266 L2.472,14.266 L2.472,11.378 L1.946,11.378 L1.946,14.266 Z M15.4,14.266 L15.254,14.266 L15.254,2.909 C15.254,2.407 14.841,2 14.333,2 L13.253,2 C12.745,2 12.331,2.407 12.331,2.909 L12.331,14.266 L11.394,14.266 L11.394,8.233 C11.394,7.732 10.98,7.324 10.472,7.324 L9.392,7.324 C8.884,7.324 8.47,7.732 8.47,8.233 L8.47,14.266 L7.533,14.266 L7.533,5.998 C7.533,5.496 7.119,5.089 6.611,5.089 L5.531,5.089 C5.023,5.089 4.609,5.496 4.609,5.998 L4.609,14.266 L3.672,14.266 L3.672,11.086 C3.672,10.585 3.258,10.177 2.75,10.177 L1.667,10.177 C1.159,10.177 0.746,10.585 0.746,11.086 L0.746,14.266 L0.6,14.266 C0.269,14.266 0,14.534 0,14.866 C0,15.197 0.269,15.466 0.6,15.466 L15.4,15.466 C15.732,15.466 16,15.197 16,14.866 C16,14.534 15.732,14.266 15.4,14.266 L15.4,14.266 Z",
    id: "path-4f93b60c-5aa2-426a-8e8c-4a8dfd8dc696"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons-/-Navigation-/-analytics"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-4f93b60c-5aa2-426a-8e8c-4a8dfd8dc696",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-4f93b60c-5aa2-426a-8e8c-4a8dfd8dc696"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Icon-shape",
    fill: "#868B92",
    xlinkHref: "#path-4f93b60c-5aa2-426a-8e8c-4a8dfd8dc696"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Icon-color",
    fill: "#868B92",
    mask: "url(#mask-4f93b60c-5aa2-426a-8e8c-4a8dfd8dc696)",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnalytics);
export default __webpack_public_path__ + "static/media/analytics.51a979fd96f7d269c0e95795c37ba42c.svg";
export { ForwardRef as ReactComponent };